// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import type { Icon } from 'iconsax-react';

const StatusArchiveIcon: Icon = ({ size = 16, color, variant: _variant, className, style, ...rest }) => {
  const fill = color || 'currentColor';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...rest}
    >
      <path d="M11 15.1668H5C2.8 15.1668 2.5 13.9668 2.5 12.6668V6.81348C2.5 6.54014 2.72667 6.31348 3 6.31348C3.27333 6.31348 3.5 6.54014 3.5 6.81348V12.6668C3.5 13.8268 3.7 14.1668 5 14.1668H11C12.3 14.1668 12.5 13.8268 12.5 12.6668V6.81348C12.5 6.54014 12.7267 6.31348 13 6.31348C13.2733 6.31348 13.5 6.54014 13.5 6.81348V12.6668C13.5 13.9668 13.2 15.1668 11 15.1668Z" fill={fill} />
      <path d="M12.6666 7.16634H3.33325C1.71992 7.16634 0.833252 6.27967 0.833252 4.66634V3.33301C0.833252 1.71967 1.71992 0.833008 3.33325 0.833008H12.6666C14.2799 0.833008 15.1666 1.71967 15.1666 3.33301V4.66634C15.1666 6.27967 14.2799 7.16634 12.6666 7.16634ZM3.33325 1.83301C2.27992 1.83301 1.83325 2.27967 1.83325 3.33301V4.66634C1.83325 5.71967 2.27992 6.16634 3.33325 6.16634H12.6666C13.7199 6.16634 14.1666 5.71967 14.1666 4.66634V3.33301C14.1666 2.27967 13.7199 1.83301 12.6666 1.83301H3.33325Z" fill={fill} />
      <path d="M9.21327 9.83301H6.7866C6.51329 9.83301 6.28662 9.60634 6.28662 9.33301C6.28662 9.05967 6.51329 8.83301 6.7866 8.83301H9.21327C9.4866 8.83301 9.71327 9.05967 9.71327 9.33301C9.71327 9.60634 9.4866 9.83301 9.21327 9.83301Z" fill={fill} />
    </svg>
  );
};

export { StatusArchiveIcon };
